import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_3 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 0 }

import { 
  IonButtons,
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonItem,
  IonIcon,
  IonRadioGroup,
  IonRadio,
  IonLabel,
  IonList,
  IonListHeader,
  IonSearchbar,
  IonSpinner,
  IonTitle,
  IonToolbar,
  modalController,
} from "@ionic/vue";
import { onBeforeMount, ref ,computed } from "vue";
import { closeOutline, saveOutline } from "ionicons/icons";
import { useStore } from "@/store";
import { getCurrentTime } from "@/utils";
import { translate,useUserStore } from '@hotwax/dxp-components';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimezoneModal',
  props: {
  showBrowserTimeZone: {
    type: Boolean,
    default: true
  },
  showDateTime: {
    type: Boolean,
    default: true
  },
  dateTimeFormat: {
    type: String,
    default: 't ZZZZ'
  }
},
  setup(__props) {

const store = useStore();
const userStore=useUserStore()
let queryString = ref("")
let filteredTimeZones = ref<any[]>([])
let timeZones = computed(() => userStore.getTimeZones)
let timeZoneId = ref("")
let isLoading = ref(true)
const userProfile = computed(() => store.getters["user/getUserProfile"])
const browserTimeZone = ref({
  label: '',
  id: Intl.DateTimeFormat().resolvedOptions().timeZone
})

const props = __props;

onBeforeMount(async() => {
  isLoading.value = true;
  await userStore.getAvailableTimeZones();
  if(userProfile.value && userProfile.value.timeZone) {
    userStore.currentTimeZoneId = userProfile.value.timeZone
    timeZoneId.value = userProfile.value.timeZone
  }

  if(props.showBrowserTimeZone) {
    browserTimeZone.value.label = timeZones.value.find((timeZone: any) => timeZone.id.toLowerCase().match(browserTimeZone.value.id.toLowerCase()))?.label
  }
  findTimeZone();
  isLoading.value = false;
})

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

function findTimeZone() { 
  const searchedString = queryString.value.toLowerCase();
  filteredTimeZones.value = timeZones.value.filter((timeZone: any) => timeZone.id.toLowerCase().match(searchedString) || timeZone.label.toLowerCase().match(searchedString));

  if(props.showBrowserTimeZone) {
    filteredTimeZones.value = filteredTimeZones.value.filter((timeZone: any) => !timeZone.id.toLowerCase().match(browserTimeZone.value.id.toLowerCase()));
  }
}

function selectSearchBarText(event: any) {
  event.target.getInputElement().then((element: any) => {
    element.select();
  })
}

async function setUserTimeZone() {
  return store.dispatch("user/setUserTimeZone", {
    "tzId": timeZoneId.value
  }).then(() => {
    closeModal()
  })
}

function preventSpecialCharacters($event: any) {
  // Searching special characters fails the API, hence, they must be omitted
  if(/[`!@#$%^&*()_+\-=\\|,.<>?~]/.test($event.key)) $event.preventDefault();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Select time zone")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSearchbar), {
              onIonFocus: _cache[0] || (_cache[0] = ($event: any) => (selectSearchBarText($event))),
              placeholder: _unref(translate)('Search time zones'),
              modelValue: _unref(queryString),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(queryString) ? (queryString).value = $event : queryString = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_isRef(queryString) //@ts-ignore
 ? queryString.value = $event.target.value : queryString = $event.target.value; findTimeZone()}, ["enter"])),
              onKeydown: _cache[3] || (_cache[3] = ($event: any) => (preventSpecialCharacters($event)))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRadioGroup), {
          value: "rd",
          modelValue: _unref(timeZoneId),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(timeZoneId) ? (timeZoneId).value = $event : timeZoneId = $event))
        }, {
          default: _withCtx(() => [
            (__props.showBrowserTimeZone)
              ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonListHeader), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Browser time zone")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonRadio), {
                          "label-placement": "end",
                          justify: "start",
                          value: browserTimeZone.value.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(browserTimeZone.value.label) + " (" + _toDisplayString(browserTimeZone.value.id) + ") ", 1),
                                (__props.showDateTime)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(getCurrentTime)(browserTimeZone.value.id, __props.dateTimeFormat)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonList), null, {
              default: _withCtx(() => [
                (__props.showBrowserTimeZone)
                  ? (_openBlock(), _createBlock(_unref(IonListHeader), { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Select a different time zone")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(isLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_unref(IonItem), { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonSpinner), {
                            name: "crescent",
                            slot: "start"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(translate)("Fetching time zones")), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (!_unref(filteredTimeZones).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("p", null, _toDisplayString(_unref(translate)("No time zone found")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTimeZones), (timeZone) => {
                          return (_openBlock(), _createBlock(_unref(IonItem), {
                            key: timeZone.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonRadio), {
                                value: timeZone.id,
                                "label-placement": "end",
                                justify: "start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(timeZone.label) + " (" + _toDisplayString(timeZone.id) + ") ", 1),
                                      (__props.showDateTime)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(getCurrentTime)(timeZone.id, __props.dateTimeFormat)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_unref(IonFab), {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), {
              disabled: !_unref(timeZoneId),
              onClick: setUserTimeZone
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})